import { GetPriceEstimateWithFeesArgs } from 'types/api/arguments/get-price-estimate-with-fees-args'
import { GetPriceEstimateWithFeesResponse } from 'types/api/response/get-price-estimate-with-fees-response'

import { api } from './api'

export const getPriceEstimateWithFees = (args: GetPriceEstimateWithFeesArgs) =>
  api.post<GetPriceEstimateWithFeesResponse>('offer/estimate_with_fees', args)
